define('modules/integrations/router',['require','exports','module','jquery','backbone','modules/private/index','modules/accounts/groups/index','modules/start/index','./view','./services/zapier/index','./services/shopify/index','./services/api/index','env','mdnotice'],function (require, exports, module) {
  "use strict";

  var $ = require("jquery"),
    Backbone = require("backbone"),
    Private = require("modules/private/index"),
    Groups = require("modules/accounts/groups/index"),
    Start = require("modules/start/index"),
    MainView = require("./view"),
    Zapier = require("./services/zapier/index"),
    Shopify = require("./services/shopify/index"),
    Api = require("./services/api/index"),
    Config = require("env"),
    mdNotice = require("mdnotice");

  var TAB_CONTENT = "#integrations-tab-content";

  var init = function (activeTab, callback) {
    Private.init(function (me) {
      var group = new Groups.Model(),
        products = new Start.Products();

      var mainViewData = {
        el: "#content",
        me: me,
        group: group,
        products: products,
        serviceToRender: callback,
        service: activeTab,
      };

      var mainView = new MainView(mainViewData);

      var productsFetch = function () {
        products.fetch({
          success: function () {
            mainView.render();
            initMDNotice(me);
            callback(me, group);
          },
        });
      };

      group.fetch({ success: productsFetch });
    });
  };

  var initMDNotice = function (me) {
    mdNotice.init({
      el: "#noticeContainer",
      url: Config.backendUrl + "/notice/signup",
      userData: {
        user: me.getName(),
        userType: me.getRole(),
        product: "signup",
        name: me.getName(),
        lang: $.i18n.detectLanguage(),
      },
    });
  };

  module.exports = Backbone.Router.extend({
    initialize: function () {},
    routes: {
      "integrations(/)": "initZapier",
      "integrations/service/zapier": "initZapier",
      "integrations/service/shopify": "initShopify",
      "integrations/service/api": "initApi",
    },

    initZapier: function () {
      var self = this;
      init("zapier", function (me, group) {
        var viewParams = {
          el: TAB_CONTENT,
          me: me,
          group: group,
        };
        var zapierView = new Zapier.View(viewParams);
        zapierView.render();
        self.afterRender();
      });
    },

    initShopify: function () {
      var self = this;
      init("shopify", function (me, group) {
        var viewParams = {
          el: TAB_CONTENT,
          me: me,
          group: group,
          model: new Shopify.Model(),
        };

        new Shopify.View(viewParams).render();

        self.afterRender();
      });
    },

    initApi: function () {
      if (!Config.integrations.APIsEnabled) {
        location.href = Config.defaultDomain + "accounts/user/me";
      }

      var self = this;

      init("api", function (me, group) {
        var viewParams = {
          el: TAB_CONTENT,
          me: me,
          group: group,
          model: new Api.Model(),
          collection: new Api.Collection(),
        };

        new Api.View(viewParams).render();
        self.afterRender();
      });
    },

    afterRender: function () {
      $(".i18n").i18n();
    },
  });
});

